/**
 * useLeaveTypes — 106-2 React Query hook tenant leave-type katalógushoz.
 *
 * A LeaveRequestForm Select value-jához a backend UUID-t vár (Zod .uuid()),
 * így a frontend NEM küldhet enum-kódot ("ANNUAL"). Ez a hook biztosítja
 * a code → UUID mappinget.
 */

import { useQuery } from '@tanstack/react-query';
import { getLeaveTypes, type LeaveType } from '../api/hr-api';

export const leaveTypesQueryKey = ['hr', 'leave', 'types'] as const;

export function useLeaveTypes() {
  return useQuery<LeaveType[]>({
    queryKey: leaveTypesQueryKey,
    queryFn: async () => {
      const res = await getLeaveTypes();
      return res.data;
    },
    // Ritkán változik — 5 percig friss
    staleTime: 5 * 60_000,
  });
}
